import React from 'react';
import { connect } from 'react-redux';
import {
    Paper,
    Typography,
    Divider,
    makeStyles,
    TableHead,
    TableCell,
    TableRow,
    Table,
    TableBody,
    TableFooter,
    TablePagination,
} from '@material-ui/core';
import { getExercisesListSelector } from "../../state/Exercises"
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    main: {
        padding: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
    },
    section: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    label: {
        fontWeight: "700",
    },
    table: {
        overflowY: "auto",
        [theme.breakpoints.down('xs')]: {
            maxHeight: theme.spacing(45),
            minWidth: theme.spacing(35),
        },
        [theme.breakpoints.up('sm')]: {
            maxHeight: theme.spacing(70),
            minWidth: theme.spacing(65),
        },
    },
}))

const Exercises = props => {

    const {exercises} = props

    const classes = useStyles();
    const [offset, setOffset] = React.useState(0)

    const limit = 10
    const count = exercises.length
    const pageEnd = offset+limit < count ? offset+limit : count
    const data = exercises.slice(offset, pageEnd)

    const paginationRow = (
        <TableRow>
            <TablePagination
             rowsPerPage={limit}
             rowsPerPageOptions={[]}
             count={count}
             page={offset/limit}
             onChangePage={(e,page)=>{setOffset(page*limit)}}
            />
        </TableRow>
    )

    return (
        <Paper elevation={6} className={classes.main}>
            <div className={classes.section}>
                <Typography variant="h4">Exercises</Typography>
            </div>
            <Divider />
            <div className={classes.section}>
                <Link color="inherit" to={`/exercises/new`}>New</Link>
            </div>
            <Divider />
            <div className={classes.section}>
                <div className={classes.table}>
                <Table>
                    {count > limit && <TableHead>{paginationRow}</TableHead>}
                    <TableBody>
                        {data.map(exercise => (
                            <TableRow key={exercise.id}>
                                <TableCell><Link to={`/exercises/${exercise.id}`}>{exercise.name}</Link></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    {count > limit && <TableFooter>{paginationRow}</TableFooter>}
                </Table>
                </div>
            </div>
        </Paper>
    )
}

const mapStateToProps = state => {
    const exercises = getExercisesListSelector(state)
    return {exercises}
}

export default connect(mapStateToProps)(Exercises)
